import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  BeehiveAzureSubscriptionsClient,
  beehiveAzureSubscriptionsApiRef,
} from './apis/azureSubscriptions';
import {
  BeehiveScaffolderEnvironmentsClient,
  beehiveScaffolderEnvironmentsApiRef,
} from './apis/scaffolderEnvironments';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: beehiveAzureSubscriptionsApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new BeehiveAzureSubscriptionsClient({ discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: beehiveScaffolderEnvironmentsApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new BeehiveScaffolderEnvironmentsClient({ discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
];
